import React, { useState, useEffect } from "react";
import { ContactCardsModel } from "./models/ContactCards.model";
import {
  Image,
  Link,
  RichText,
  Text,
  isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import { ContactCardModel } from "./models/ContactCard.model";
import ModalDialog from "../../react-only-components/ModalDialog/ModalDialog";
import { anchorWithId } from "../../helpers/anchorWithId.helper";
import FullCard from "./fullcard";
import useMediaQuery from "../../hooks/useMediaQuery";

const ContactCards = (props) => {
  const model = new ContactCardsModel(props);
  const isEE = props.sitecoreContext?.pageEditing;
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const contactCardList = model?.contactCards?.ContactCardsLists;
  const contactCardTitle = model?.contactCards?.ContactCardTitle;

  const variation = () => {
    return props?.params?.Variations;
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState<ContactCardModel>();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const onReadMoreHandler = (data: ContactCardModel) => {
    //e.preventDefault();
    setModalData(data);
    // setModalData({fullname:data.fullname ,
    //                 designation:data.designation,
    //                 description:data.description});
    //data.CTA.href = "javascript:void(0)";
    openModal();
  };

  return (
    <>
      <ModalDialog
        isOpen={modalIsOpen}
        close={closeModal}
        className="contact-card-modal"
      >
        <div className="contact-cards__modalwrapper" id={props?.rendering?.uid}>
          <div className="contact-cards__modalwrapperSubA">
            {" "}
            {(modalData?.image || modalData?.imageMobile) && (
              <div className="contact-card__image--wrapper">
                <Image
                  loading="lazy"
                  field={modalData?.image}
                  className="contact-card__image--desktop"
                />
                <Image
                  loading="lazy"
                  field={
                    modalData?.imageMobile ?
                      (Object.keys(modalData?.imageMobile?.value ?? {}).length > 0
                      ? modalData?.imageMobile
                      : modalData?.allowFallbackForMobile ? modalData?.image : undefined) : undefined
                  }
                  className="contact-card__image--mobile"
                />
              </div>
            )}
          </div>
          <div className="contact-cards__modalwrapperSubB">
            {modalData?.fullname && (
              <RichText
                className=" contact-card__fullname--modal"
                field={modalData?.fullname}
                tag="h3"
              // encode={false}
              />
            )}
            {modalData?.designation && (
              <RichText
                className=" contact-card__designation--modal"
                field={modalData?.designation}
                tag="p"
              // encode={false}
              />
            )}
            {modalData?.description && (
              <RichText
                className=" contact-card__description"
                field={modalData?.description}
                tag="p"
              // encode={false}
              />
            )}
            {modalData?.download?.value?.src &&
              modalData?.SecondaryDownloadLink?.value?.src && (
                <div className="contact-card__footer--photodownload">
                  {modalData?.titleButtons?.value && (
                    <div className="contact-card__title-buttons--photodownload">
                      <Text field={modalData?.titleButtons} />
                    </div>
                  )}
                  <div className="contact-card__footer--photodownload2">
                    {modalData?.download?.value?.src && (
                      <div
                        className={
                          modalData?.CTA?.value?.text ||
                            modalData?.CTA?.value?.href
                            ? "contact-card__secondary-link secondary-link secondary-link-blue"
                            : "contact-card__secondary-link secondary-link secondary-link-blue ml-0"
                        }
                      >
                        <span className="link-with-arrow link-with-arrow--text">
                          <a
                            href={anchorWithId(
                              modalData?.download?.value?.src,
                              modalData?.download?.value?.anchor
                            )}
                            download
                          >
                            <Text field={modalData?.curriculumTextModal} />
                            <pfe-icon size={24} icon="cnh-download" />
                          </a>
                        </span>
                      </div>
                    )}
                    <div
                      className={
                        modalData?.CTA?.value?.text ||
                          modalData?.CTA?.value?.href
                          ? "contact-card__secondary-link secondary-link secondary-link-blue contact-card__secondary-attchment"
                          : "contact-card__secondary-link secondary-link secondary-link-blue ml-0"
                      }
                    >
                      {modalData?.SecondaryDownloadLink?.value?.src && (
                        <span className="link-with-arrow link-with-arrow--text">
                          <a
                            href={anchorWithId(
                              modalData?.SecondaryDownloadLink?.value?.src,
                              modalData?.SecondaryDownloadLink?.value?.anchor
                            )}
                            target={
                              modalData?.secondaryTarget?.value &&
                                modalData?.secondaryTarget?.value !== ""
                                ? modalData?.secondaryTarget?.value
                                : "_blank"
                            }
                          >
                            <Text
                              field={modalData?.SecondaryDownloadlinkText}
                            />
                            {/* <span>{card?.curriculum?.value}</span> */}
                            <pfe-icon size={24} icon="cnh-download" />
                          </a>
                          {/* <pfe-icon icon="cnh-download" size={'24'} color={'complement'} /> */}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </ModalDialog>
      {props.fields && contactCardList && (
        <div
          className={
            props?.fields?.Variant?.value === "v2" //v2
              ? "contact-cardsWrapper contact-cardsWrapperA"
              : props?.fields?.Variant?.value === "v3" //v3
                ? "contact-cardsWrapper contact-cardsWrapperB"
                : props?.fields?.Variant?.value === "v4" //v3
                  ? "contact-cardsWrapper contact-cardsWrapperC"
                  : "contact-cardsWrapper"
          }
          id={props?.rendering?.uid}
        >
          {contactCardTitle?.value !== "Meet our Portfolio Companies" &&
            contactCardTitle?.value !== "Our Strategic Partners" && (
              <RichText
                className="conatactCard-title__text"
                field={contactCardTitle}
                tag="span"
              />
            )}
          {
            (model.columnLayout === '1-columnLayout' && isDesktop) ?
              <FullCard
                contactCardList={contactCardList}
                onReadMoreHandler={onReadMoreHandler}
              /> :
              <div className={`contact-cards contact-cards--${model.columnLayout}`}>
                {contactCardList.map((item, index) => {
                  const card = new ContactCardModel(item);
                  return variation() !== "withemailandmobile" ? (
                    <div className="contact-card" key={index}>
                      <div className="contact-card__image--wrapper">
                        <Image
                          loading="lazy"
                          field={card?.image}
                          className="contact-card__image--desktop"
                        />
                        <Image
                          loading="lazy"
                          field={
                            card?.imageMobile ?
                              (Object.keys(card?.imageMobile?.value ?? {}).length > 0
                              ? card?.imageMobile
                              : (card?.allowFallbackForMobile ? card?.image : undefined)) : undefined
                          }
                          className="contact-card__image--mobile"
                        />
                      </div>
                      <div className="contact-card__content">
                        <RichText
                          className=" contact-card__fullname"
                          field={card?.fullname}
                          tag="h3"
                        />
                        <RichText
                          className=" contact-card__designation"
                          field={card?.designation}
                          tag="p"
                        />
                      </div>

                      <div className="contact-card__footer">
                        {(card?.CTA?.value?.text || card?.CTA?.value?.href) && (
                          <div className="contact-card__cta-link cta cta-primary cta-primary-white2">
                            {isEditorActive() && (
                              <Link
                                field={card?.CTA}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onReadMoreHandler(card);
                                }}
                              />
                            )}

                            {card?.description?.value && card.CTA ? (
                              <Link
                                field={card?.CTA}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onReadMoreHandler(card);
                                }}
                              />
                            ) : (
                              <Link field={card?.CTA} />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="contact-card-full" key={index}>
                      <div className="contact-card__image--wrapper">
                        <Image
                          loading="lazy"
                          field={card?.image}
                          className="contact-card-full__image--desktop"
                        />
                        <Image
                          loading="lazy"
                          field={
                            card?.imageMobile ? 
                              (Object.keys(card?.imageMobile?.value ?? {}).length > 0
                              ? card?.imageMobile
                              : (card?.allowFallbackForMobile ? card?.image : undefined)) : undefined
                          }
                          className="contact-card-full__image--mobile"
                        />
                      </div>
                      <div className="contact-card-full__content">
                        <RichText
                          className=" contact-card-full__country"
                          field={card?.country}
                          tag="span"
                        // encode={false}
                        />
                        <RichText
                          className=" contact-card-full__fullname"
                          field={card?.fullname}
                          tag="h3"
                        // encode={false}
                        />
                        <RichText
                          className="contact-card-full__designation"
                          field={card?.designation}
                          tag="p"
                        // encode={false}
                        />

                        {card?.mobile1?.value ? (
                          <div className="contact-card-full__spec-container">
                            {/* <span className='contact-card-full__spectitle'>
                        Mobile
                      </span> */}

                            <Link
                              field={{ value: `tel:${card?.mobile1?.value}` }}
                              className="mobile-details"
                              href={`tel:${card?.mobile1?.value}`}
                            >
                              {card?.mobile1?.value}
                            </Link>
                          </div>
                        ) : null}

                        {card?.mobile2?.value ? (
                          <div className="contact-card-full__spec-container-2">
                            {/* <span className='contact-card-full__spectitle'>
                        Mobile
                      </span> */}
                            <Link
                              field={{ value: `tel:${card?.mobile2?.value}` }}
                              className="mobile-details"
                              href={`tel:${card?.mobile2?.value}`}
                            >
                              {card?.mobile2?.value}
                            </Link>
                          </div>
                        ) : null}
                        {card?.email?.value?.href ? (
                          <div className="contact-card-full__footer">
                            <a
                              href={anchorWithId(
                                card?.email?.value?.href,
                                card?.email?.value?.anchor
                              )}
                              className="contact-card-full__email"
                            >
                              {card?.email?.value?.text}
                              <span className="link-with-arrow link-with-arrow--text">
                                <pfe-icon
                                  icon="cnh-email-line"
                                  size={"24"}
                                  color={"complement"}
                                />
                              </span>
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
          }
        </div>
      )}
    </>
  );
};

export default ContactCards;
